import React, { Component } from "react";
import nordicsMap from "../../assets/nordics.json";
import styled from "styled-components";
import {
  ComposableMap,
  ZoomableGroup,
  Geographies,
  Geography,
  Markers,
  Marker
} from "react-simple-maps";
import { Motion, spring } from "react-motion";
import baseStyles from "../../styles/baseStyles";

const wrapperStyles = {
  width: "100%",
  maxWidth: 980,
  margin: "0 auto"
};

const cities = [
  { name: "Stockholm", coordinates: [18.06324, 59.334591] },
  { name: "Gothenburg", coordinates: [11.966667, 57.7] },
  { name: "Copenhagen", coordinates: [12.568337, 55.676098] },
  { name: "Oslo", coordinates: [10.757933, 59.911491] },
  { name: "Helsinki", coordinates: [24.9375, 60.170833] },
  { name: "Reykjavík", coordinates: [-21.933333, 64.133333] }
  // More to add, maybe putting that info outside where we already have a list of cities. will make linking them to the routing easier
];

const defaultMapCenter = [4, 63];
const defaultZoom = 3;

// We can easily add a menu with the cities, onClick on a city triggers handleCityClick and goes to the right city
const defs = (
  <defs>
    <linearGradient id="primaryGradient">
      <stop offset="0%" stopColor="#32A7CF" />
      <stop offset="100%" stopColor="#2886A6" />
    </linearGradient>
    <filter id="boxShadow" x="0" y="0">
      <feDropShadow
        dx="0"
        dy="3"
        stdDeviation="2"
        floodColor="#515555"
        floodOpacity="0.3"
      />
    </filter>
  </defs>
);

const Country = styled(Geography)`
  fill: ${props => (props.active ? "url(#primaryGradient)" : "#eceff1")};
  stroke: transparent;
  stroke-width: 5;
  outline: none;
  transition: 0.3s fill ease;
  :hover {
    fill: ${props =>
      props.active ? "url(#primaryGradient)" : baseStyles.color.lightGray};
  }
  :active {
    outline: none;
  }
`;

const StyledMarker = styled(Marker)``;

const MarkerLabel = styled.text`
  font-family: Lato;
  font-size: 12px;
  fill: ${baseStyles.color.lightGray};
  font-weight: 600;
  -webkit-text-stroke-color: #fff;
  -webkit-text-stroke-width: 2px;
`;

class Map extends Component {
  state = {
    center: defaultMapCenter,
    zoom: defaultZoom
  };

  handleCountryClick = country => {
    this.props.onSelectCountry(country.properties.ADMIN);
    // this.setState({
    //   zoom: 3,
    //   center: country.geometry.coordinates
    // });
  };
  render() {
    return (
      <div style={wrapperStyles}>
        <Motion
          defaultStyle={{
            zoom: defaultZoom,
            x: defaultMapCenter[0],
            y: defaultMapCenter[1]
          }}
          style={{
            zoom: spring(this.state.zoom, { stiffness: 210, damping: 20 }),
            x: spring(this.state.center[0], { stiffness: 210, damping: 20 }),
            y: spring(this.state.center[1], { stiffness: 210, damping: 20 })
          }}
        >
          {({ zoom, x, y }) => (
            <ComposableMap
              projectionConfig={{ scale: 500 }}
              width={980}
              height={551}
              defs={defs}
              style={{
                width: "100%",
                height: "auto"
              }}
            >
              <ZoomableGroup center={[x, y]} zoom={zoom} disablePanning>
                <Geographies geography={nordicsMap} disableOptimization>
                  {(geographies, projection) =>
                    geographies.map((geography, i) => {
                      const active =
                        geography.properties.ADMIN ===
                        this.props.selectedCountry;
                      return (
                        geography.id !== "010" && (
                          <Country
                            active={active}
                            onClick={this.handleCountryClick}
                            key={geography.properties.ADMIN + i}
                            cacheId={geography.properties.ADMIN + active}
                            geography={geography}
                            projection={projection}
                          />
                        )
                      );
                    })
                  }
                </Geographies>
                <Markers>
                  {cities.map((city, i) => (
                    <StyledMarker key={i} marker={city}>
                      <circle
                        cx={0}
                        cy={0}
                        r={2}
                        fill="none"
                        stroke={baseStyles.color.gray}
                        strokeWidth={2}
                      />
                      <MarkerLabel x={7} y={3.5}>
                        {city.name}
                      </MarkerLabel>
                    </StyledMarker>
                  ))}
                </Markers>
              </ZoomableGroup>
            </ComposableMap>
          )}
        </Motion>
      </div>
    );
  }
}

export default Map;



// WEBPACK FOOTER //
// ./src/components/Map/index.js